/** Matches backend ``is_unfilled_shell_brand`` / substantive onboarding fields. */
export function brandHasPitchContent(b) {
  if (!b) return false;
  return !!(
    (b.company_name || "").trim() ||
    (b.core_offering || "").trim() ||
    (b.icp || "").trim() ||
    (b.custom_context || "").trim()
  );
}

export function brandOnboardingDetailsComplete(form) {
  return (
    (form.company_name || "").trim() &&
    (form.core_offering || "").trim() &&
    (form.icp || "").trim()
  );
}
